<div class="board-column">

    <div class="column-header">
        <div class="column-title">
            <ng-container *ngIf="tasksForMe">
                <span>My Tasks</span>
            </ng-container>
            <ng-container *ngIf="!tasksForMe">
                <span style="margin-right: 0.5em;">Other Tasks</span>
                <br *ngIf="isTablet || isMobile">
                <ng-container *ngIf="!usersLoading">
                    <p-dropdown [ngModelOptions]="{standalone: true}" [options]="users" [(ngModel)]="firstUser"
                                optionLabel="name" placeholder="User" [virtualScroll]="true" [itemSize]="31"
                                (onChange)="onFirstUserChange()" [filter]="true" [showClear]="true"
                                filterBy="name,username,shortCode,phone,email"
                                styleClass="users-filter-panel left-panel">
                    </p-dropdown>
                    >
                    <p-dropdown [ngModelOptions]="{standalone: true}" [options]="users" [(ngModel)]="secondUser"
                                styleClass="users-filter-panel right-panel" optionLabel="name" placeholder="User"
                                [virtualScroll]="true" [itemSize]="31" (onChange)="onSecondUserChange()" [filter]="true"
                                filterBy="name,username,shortCode,phone,email"
                                [showClear]="true">
                    </p-dropdown>
                </ng-container>
            </ng-container>
        </div>
        <div class="column-actions">
            <i *ngIf="sortMode !== 'default'"
               [class]="sortOrder === 'ASC' ? 'pi pi-sort-amount-up-alt' : 'pi pi-sort-amount-down'"
               (click)="toggleSortOrder()"
               class="action-icon"
               [pTooltip]="sortOrder === 'ASC' ? 'Oldest first' : 'Newest first'"
               tooltipPosition="bottom">
            </i>
            <span class="sort-mode-button"
                  (click)="cycleSortMode()"
                  pTooltip="Sorting mode"
                  tooltipPosition="bottom">
				{{ getCurrentSortMode().label }}
			</span>
            <i class="pi pi-plus-circle action-icon"
               (click)="createNewTask()"
               pTooltip="Create new task"
               tooltipPosition="bottom">
            </i>
        </div>
    </div>

    <!-- <div class="tasks-container" cdkDropList [cdkDropListData]="column" (cdkDropListDropped)="onDropIn($event)"
        *libInView> -->


    <ng-container *ngIf="tasksLoading">
        <lib-progress-spinner></lib-progress-spinner>
    </ng-container>

    <div class="tasks-container" *ngIf="!tasksLoading">

        <div class="card-wrapper"
             *ngFor="let task of tasks"
             [ngClass]="{'task-for-me': tasksForMe, 'task-not-for-me': !tasksForMe}">
            <app-task-card [id]="task.id" [task]="task"
                           (click)="editTask(task)"
                           [showFrom]="!tasksForMe"
                           [isCollapsed]="task.collapsed"
                           (collapseToggle)="toggleTaskCollapse(task)">
            </app-task-card>
        </div>
    </div>
</div>
